import ContactForm from "../components/ContactForm";
import ContactInfo from "../components/ContactInfo";

const Contact = () => {
  return (
    <div className="py-10 px-4 max-w-5xl mx-auto">
      <ContactInfo />
      <ContactForm />
    </div>
  );
};

export default Contact;